import { AlertComponent } from './alert.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, FontAwesomeModule],
  exports: [AlertComponent],
})
export class AlertModule {}
